import { useEffect, useMemo } from 'react';

import { AdministrableEmployerViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { OptionType, Select, useSelectSingle } from '@foradevelopment/fora-ui';

import { changeEmployerAndGetToken } from '../../redux/auth/authThunks';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { useTypedTranslation } from '../../i18n/i18n';

export const ChangeEmployerDropdown = ({
  currentPartnerNumber,
}: {
  currentPartnerNumber: string | null | undefined;
}) => {
  const { t } = useTypedTranslation();
  const dispatch = useAppDispatch();
  const administrableEmployers = useAppSelector(state => state.employer.administrableEmployers);

  const options = useMemo(
    () => getAdminstrableEmployersOptions(t('filter.selectorLabels.selectAllCompanies'), administrableEmployers),
    [administrableEmployers, t]
  );
  const employerInput = useSelectSingle(options.find(e => e.id === currentPartnerNumber)?.id || MULTI_OPTION);

  useEffect(() => {
    if (employerInput.props.value !== currentPartnerNumber) {
      const partnerNumberOrganization = employerInput.props.value === MULTI_OPTION ? null : employerInput.props.value;
      dispatch(changeEmployerAndGetToken({ partnerNumberOrganization }));
    }
  }, [currentPartnerNumber, dispatch, employerInput.props.value]);

  return (
    <Select
      search={options.length > 6}
      testId="test-select-employer"
      label={t('common.actions.selectOrganization')}
      options={options}
      {...employerInput.props}
      itemsHaveDescription
      hideLabel
    />
  );
};

const MULTI_OPTION = 'multi';

const getAdminstrableEmployersOptions = (
  multiOptionName: string,
  administrableEmployers: AdministrableEmployerViewModel[]
): OptionType[] => {
  const options = administrableEmployers.map<OptionType>(emp => ({
    id: emp.partnerNumber,
    name: emp.organizationName,
    description: emp.organizationNumber,
  }));

  options.unshift({ id: MULTI_OPTION, name: multiOptionName });

  return options;
};
